export default {
  namespaced: true,
  simulacrum: {
    title: "Simulacro",
    simulacrums_title: "Simulacros",
    new: "Nuevo Simulacro",
    reference_number: "Número de Referencia",
    select_form: "Selecciona formularios",
    select_form_place_holder: "Seleccione un formulario",
    selected_form: "Formulario seleccionado",
    answer_form: "Iniciar formulario",
    start_form: "Iniciar formulario",
    confirm_delete: "¿Estás seguro de eliminar este simulacro?",
    no_records: "No se encontraron simulacros",
    reassign: "Reasignar",
    template: {
      title: "Plantillas de formulario",
      question: "Pregunta | Preguntas",
      options: "Opciones",
    },
    confirm_cancel: "¿Estás seguro de que deseas cancelar este simulacro?",
    canceled: "Simulacro cancelado",
  },
};


